// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_fVY","cls2":"JournalSubscriptionPage-cls2_YxX JournalSubscriptionPage-cls1_fVY"};